import React from 'react';
import { Gift, Zap } from 'lucide-react';
export const AlertBar: React.FC = () => {
  return <div className="sticky top-0 z-50 bg-brand-wine text-brand-cream py-2 px-4 shadow-md" data-id="element-13">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm sm:text-base font-medium text-center" data-id="element-14">
        <span className="flex items-center gap-1" data-id="element-15">
          <Zap className="w-4 h-4 text-brand-gold" data-id="element-16" />
          Últimos 3 Cupos en Oferta!
        </span>
        <span className="hidden sm:inline opacity-50" data-id="element-17">|</span>
        <span className="flex items-center gap-1" data-id="element-18">
          <Gift className="w-4 h-4 text-brand-gold" data-id="element-19" />
          -50% OFF — Oferta termina pronto
        </span>
      </div>
    </div>;
};